<template>
  <v-card
    class="secondary--text"
    style="height: 90vh"
    @close-dialog="close"    
  >
    <vue-scroll
      ref="lateChargesVueScrollRef"
      :ops="ops"
    >
      <v-btn
        color="info"
        icon
        class="float-right pa-6 btn--plain"
        @click="close"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <div
        style="width: 80%"
        class="pt-10 pb-4 mx-auto text-left"
      >
        <div class="custom-title pt-8 pb-4">
          Late Fees
        </div>
        <div class="pb-4">
          Select the type of fee structure agreed upon in the lease.
          You may select more than one. Enter the correct amounts. We'll calculate the rest
          for you based on the number of missed rental payments.
        </div>

        <!-- <v-checkbox-group
          style="font-size: 1rem"
          class="my-4 primary-radio-group secondary--text"
          v-model="selected"
          hide-details
        > -->
        <div class="py-6 d-flex align-center">
          <v-checkbox
            v-model="editableFlat"
            on-icon="mdi-checkbox-blank-circle"
            off-icon="mdi-checkbox-blank-circle-outline"
            class="mt-5"
          />
          <div class="pl-6">
            Flat Rate
          </div>
        </div>
        <div class="d-flex pb-6 pl-2">
          <v-text-field
            v-model="flatAmount"
            rounded
            hide-details="auto"
            solo
            flat
            dense
            type="number"
            background-color="#F0F5F6"
            style="max-width: 141px"
            class="pl-12"
            :disabled="!editableFlat"
          >
            <div slot="prepend-inner">
              $
            </div>
            <!-- <div slot="append" v-if="row.type === 'Percentage of rent'">%</div> -->
          </v-text-field>
          <div class="pl-4">
            Amount per rental period (if there is more than one fee due within the same period, enter total).
          </div>
        </div>

        <div class="py-6 d-flex align-center">
          <v-checkbox
            v-model="editablePercentage"
            on-icon="mdi-checkbox-blank-circle"
            off-icon="mdi-checkbox-blank-circle-outline"
            class="mt-5"
          />
          <div class="pl-6">
            Percentage
          </div>
        </div>
        <div class="d-flex pb-6 pl-2">
          <v-text-field
            v-model="percentage"
            rounded
            hide-details="auto"
            solo
            flat
            dense
            type="number"
            background-color="#F0F5F6"
            style="max-width: 141px"
            class="pl-12"
            :disabled="!editablePercentage"
          >
            <!-- <div slot="prepend-inner">$</div> -->
            <div slot="append">
              %
            </div>
          </v-text-field>
          <div class="pl-4">
            Percent (%) of the rent.
          </div>
        </div>

        <div class="py-6 d-flex align-center">
          <v-checkbox
            v-model="editableDaily"
            on-icon="mdi-checkbox-blank-circle"
            off-icon="mdi-checkbox-blank-circle-outline"
            class="mt-5"
          />
          <div class="pl-6">
            Daily
          </div>
        </div>

        <div class="d-flex pb-6 pl-2">
          <v-text-field
            v-model="baseAmount"
            rounded
            hide-details="auto"
            solo
            flat
            dense
            type="number"
            background-color="#F0F5F6"
            style="max-width: 141px"
            class="pl-12"
            :disabled="!editableDaily"
          >
            <div slot="prepend-inner">
              $
            </div>
            <!-- <div slot="append" v-if="row.type === 'Percentage of rent'">%</div> -->
          </v-text-field>
          <div class="pl-4">
            One-time fee (enter “0” if none).
          </div>
        </div>

        <!-- <div class="d-flex pb-6 pl-2">
          <v-text-field
            v-model="onetimeFee"
            rounded
            hide-details="auto"
            solo
            flat
            dense
            type="number"
            background-color="#F0F5F6"
            style="max-width: 141px"
            class="pl-12"
            :disabled="!editableDaily"
          >
            <div slot="prepend-inner">
              $
            </div>
          </v-text-field>
          <div class="pl-4">
            One-time fee (enter “0” if none)
          </div>
        </div> -->

        <div class="d-flex pb-6 pl-2">
          <v-text-field
            v-model="dailyAmount"
            rounded
            hide-details="auto"
            solo
            flat
            dense
            type="number"
            background-color="#F0F5F6"
            style="max-width: 141px"
            class="pl-12"
            :disabled="!editableDaily"
          >
            <div slot="prepend-inner">
              $
            </div>
            <!-- <div slot="append" v-if="row.type === 'Percentage of rent'">%</div> -->
          </v-text-field>
          <div class="pl-4">
            Amount per day.
          </div>
        </div>
        <div class="d-flex pb-6 pl-2">
          <v-text-field
            v-model="dayAmount"
            rounded
            hide-details="auto"
            solo
            flat
            dense
            type="number"
            background-color="#F0F5F6"
            style="max-width: 141px"
            class="pl-12"
            :disabled="!editableDaily"
          />
          <div class="pl-4">
            Number of days.
          </div>
        </div>
        <div class="d-flex pb-6 pl-2">
          <v-text-field
            v-model="gracePeriod"
            rounded
            hide-details="auto"
            solo
            flat
            dense
            type="number"
            background-color="#F0F5F6"
            style="max-width: 141px"
            class="pl-12"
            :disabled="!editableDaily"
          >
            <!-- <div slot="append" v-if="row.type === 'Percentage of rent'">%</div> -->
          </v-text-field>
          <div class="pl-4">
            Grace period, in days. Leave blank if does not apply.
          </div>
        </div>

        <div class="py-6 d-flex align-center">
          <v-checkbox
            v-model="editableOther"
            on-icon="mdi-checkbox-blank-circle"
            off-icon="mdi-checkbox-blank-circle-outline"
            class="mt-5"
          />
          <div class="pl-6">
            Other Type of Late Fee
          </div>
        </div>
        <div class="d-flex pb-6 pl-2">
          <v-text-field
            v-model="otherAmount"
            rounded
            hide-details="auto"
            solo
            flat
            dense
            type="number"
            background-color="#F0F5F6"
            style="max-width: 141px"
            class="pl-12"
            :disabled="!editableOther"
          >
            <div slot="prepend-inner">
              $
            </div>
            <!-- <div slot="append" v-if="row.type === 'Percentage of rent'">%</div> -->
          </v-text-field>
          <div class="pl-4">
            <div>Amount.</div>
          </div>
        </div>
        <div
          v-if="editableOther"
          class="d-flex pb-6"
        >
          <div style="padding-left: 135px; width: 100%;">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <div class="pl-4 font-weight-medium mb-2">
                  <div>Period Incurred</div>
                </div>
                <v-text-field
                  :value="timePeriodDisplay"
                  prepend-inner-icon="$calendar"
                  readonly
                  rounded
                  solo
                  flat
                  dense
                  background-color="#F0F5F6"
                  color="#003a60"
                  v-on="on"
                  @click:prepend-inner="menu = true"
                />
              </template>

              <date-range
                :max="new Date().toISOString().slice(0, 10)"
                @update:dates="updateDates"
              />
            </v-menu>
          </div>
        </div>
        <!-- </v-checkbox-group> -->
      </div>
      <v-card-actions
        style="background-color: #fafbfc; border-radius: 0px 0px 10px 10px"
        class="justify-end py-4 pr-12 mt-12"
      >
        <v-btn
          rounded
          color="accent_light"
          class="mb-2 mt-4 btn--plain capital--btn"
          text
          @click="close"
        >
          go back
        </v-btn>
        <v-btn
          rounded
          color="accent_light"
          class="px-8 mb-2 mt-4 white--text capital--btn"
          depressed
          @click="add"
        >
          add
        </v-btn>
      </v-card-actions>
    </vue-scroll>
  </v-card>
</template>

<script>
import DateRange from "@/components/DateRange.vue";
export default {
  name: "LateChargesDialog",
  components: {
    DateRange,
  },
  props: {},
  data() {
    return {
      selected: "",
      editableFlat: false,
      editablePercentage: false,
      editableDaily: false,
      editableOther: false,
      flatAmount: "",
      percentage: "",
      onetimeFee: "",
      baseAmount: "",
      dayAmount: "",
      dailyAmount: "",
      gracePeriod: "",
      otherAmount: "",
      timePeriod: [],
      timePeriodDisplay: "",
      menu: false,
      ops: {
        vuescroll: {},
        scrollPanel: {},
        rail: {
          //background: '#EAEBEB',
          opacity: 0,
          size: '5px',
          specifyBorderRadius: false,
          gutterOfEnds: null,
          gutterOfSide: '0px',
        },
        bar: {
          onlyShowBarOnScroll: false,
          keepShow: true,
          background: '#4DCCC4',
          opacity: 1,
          size: '6px',
        }
      }
    };
  },
  computed: {
    typeAmount() {
      switch (this.selected) {
        case "flat":
          return this.flatAmount;
        case "percentage":
          return this.percentage;
        case "daily":
          return this.dailyAmount;
        case "other":
          return this.otherAmount;
        default:
          return "";
      }
    },
    dateConverted: {
      get: function() {
        return this.convertDateWithSlashes(this.field);
      },
      set: function(newValue) {
        if (newValue.length < 10) {
          return newValue;
        }
        const d = new Date(newValue).toISOString();
        var d1 = d.split("T"); //spliting date from T
        this.$emit("update:field", d1[0]);
      },
    },
  },
  methods: {
    initData() {
      this.selected = "";
      this.editableFlat = false;
      this.editablePercentage = false;
      this.editableDaily = false;
      this.editableOther = false;
      this.flatAmount = "";
      this.percentage = "";
      this.onetimeFee = "";
      this.baseAmount = "";
      this.dayAmount = "";
      this.dailyAmount = "";
      this.gracePeriod = "";
      this.otherAmount = "";
      this.timePeriod = [];
      this.timePeriodDisplay = "";
      this.menu = false;

      this.$refs.lateChargesVueScrollRef.scrollTo({ x: 0, y: 0 }, 0);
    },
    close() {
      this.$emit("close:dialog");
      this.initData();
    },
    add() {
      let calculateInfoArray = [];
      if (this.editableFlat)
        calculateInfoArray.push({ type: "flat", flatAmount: this.flatAmount });
      if (this.editablePercentage)
        calculateInfoArray.push({
          type: "percentage",
          percentage: this.percentage,
        });
      if (this.editableDaily)
        calculateInfoArray.push({
          type: "daily",
          onetimeFee: this.onetimeFee,
          baseAmount: this.baseAmount,
          dailyAmount: this.dailyAmount,
          dayAmount: this.dayAmount,
          gracePeriod: this.gracePeriod,
        });
      if (this.editableOther)
        calculateInfoArray.push({
          type: "other",
          otherAmount: this.otherAmount,
          timePeriod: this.timePeriod,
          timePeriodDisplay: this.timePeriodDisplay,
        });

      this.$emit("add", calculateInfoArray);
      this.initData();
    },
    updateDates(dates) {
      this.timePeriod = dates;
      this.timePeriodDisplay = this.formatDates(dates);
    },
    formatDates(dates) {
      if (Array.isArray(dates)) {
        const date1 = this.$dayjs(dates[0]);
        const date2 = this.$dayjs(dates[1]);
        return `${date1.format("MMMM D, YYYY")} - ${date2.format(
          "MMMM D, YYYY"
        )}`;
      }
      return this.$dayjs(dates).format("MMMM D, YYYY");
    }
  },
};
</script>

<style lang="scss">

</style>
